export default "__VITE_ASSET__DQNcYMrq__"